import { CentralizedSliderBase } from "@reusejs/react";

export interface FeaturedPropertiesSliderComponentProps {
  elements: React.ReactNode[];
}

export function FeaturedPropertiesSliderComponent(
  props: FeaturedPropertiesSliderComponentProps
) {
  const LeftArrow = (props: any) => {
    return (
      <div
        className="absolute top-1/2 left-14 z-9 hidden xl:flex h-16 w-16 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-white bg-slate-800 text-white opacity-70 hover:opacity-90"
        onClick={() => {
          props.swiperRef.current.slidePrev();
        }}
      >
        {"<"}
      </div>
    );
  };

  const RightArrow = (props: any) => {
    return (
      <div
        className="absolute top-1/2 right-14 z-9 hidden xl:flex h-16 w-16 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-white bg-slate-800 text-white opacity-70 hover:opacity-90"
        onClick={() => {
          props.swiperRef.current.slideNext();
        }}
      >
        {">"}
      </div>
    );
  };

  const w = window.innerWidth;

  return (
    <CentralizedSliderBase
      gap={20}
      slidesPerView={w < 1400 ? 1 : 1.7}
      centeredSlides={true}
      loop={true}
      renderArrowLeft={LeftArrow}
      renderArrowRight={RightArrow}
      autoPlay={2000}
    >
      {props.elements}
    </CentralizedSliderBase>
  );
}
